import { useSession } from 'context/Session'
import Head from 'next/head'

import * as S from './Header.styles'

const defaultProps = {}
const propTypes = {}

export const Header = ({ title }) => {
  const { accessToken } = useSession()
  return (
    <S.Container>
      <Head>
        <title>TSN - {title}</title>
      </Head>
      <S.Content>
        <S.Title>{title}</S.Title>
        <S.ButtonContainer>
          {accessToken ? <S.CreateGroupButton /> : <div />}
        </S.ButtonContainer>
      </S.Content>
    </S.Container>
  )
}

Header.defaultProps = defaultProps
Header.propTypes = propTypes

export default Header
